import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Check, Column, OLIVE, BODY } from './DagbladFrontPage';
import { mergeItems } from '../utils/mergeShopping';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shopping-list`;

export default function DagbladShopping({ shop, evening, onHide }) {
  const [items, setItems] = useState(shop.items);
  const shown = mergeItems(items);
  const left = shown.filter((i) => !i.checked).length;
  const toggle = async (it) => {
    setItems((xs) => xs.map((x) => (it.ids.includes(x.id) ? { ...x, checked: !it.checked } : x)));
    try { await Promise.all(it.ids.map((id) => axios.patch(`${API}/${shop.monday}/items/${id}`, { checked: !it.checked }, { withCredentials: true }))); }
    catch { setItems(() => shop.items); toast.error('Kunde inte spara'); }
  };
  const title = `${evening ? 'Handla imorgon' : 'Handla idag'} · ${left ? `${left} kvar` : 'allt i korgen'}`;
  return (
    <Column title={`🧺 ${title}`} testid="dagblad-shopping" onHide={onHide}>
      {!items.length ? (
        <p className="italic text-sm opacity-70" style={{ fontFamily: BODY }} data-testid="dagblad-shopping-empty">
          Listan är tom. Be mig göra en under Veckans middagar, gumman 💛
        </p>
      ) : (
        <div className="grid sm:grid-cols-2 gap-x-6">
          {shop.aisles.map((a) => {
            const list = shown.filter((i) => i.aisle === a);
            if (!list.length) return null;
            return (
              <div key={a} className="mb-2 break-inside-avoid" data-testid={`dagblad-shop-aisle-${a}`}>
                <p className="text-[10px] font-black uppercase tracking-[0.2em]" style={{ color: OLIVE }}>{a}</p>
                {list.map((it) => (
                  <Check key={it.id} checked={it.checked} onChange={() => toggle(it)} testid={`dagblad-shop-${it.id}`}>
                    {it.name}{it.qty ? <span className="text-xs opacity-60"> · {it.qty}</span> : null}
                  </Check>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </Column>
  );
}
